import client from '../httpClient';

const schedulesSubmissionApi = (params) => {
  return client.post('/schedules/submission', JSON.stringify(params), { isShowLoading: false });
};

export default schedulesSubmissionApi;
